import React from 'react'
import { login_Url } from '../API/spotify_requests'
import './Login.css'

function Login() {
    return (
      <div className="login">
        {/* Spotify Logo */}
        <img
          src="https://livebarcelona.cat/wp-content/uploads/2016/02/open-graph-default.png"
          alt="Spotify"
        />
        {/* Spotify Login Button */}
        <a href={login_Url}>Login with Spotify</a>
      </div>
    );
}

export default Login
